import { render, staticRenderFns } from "./modal_external_people_create.vue?vue&type=template&id=93a6f1d6&scoped=true"
import script from "./modal_external_people_create.vue?vue&type=script&lang=js"
export * from "./modal_external_people_create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a6f1d6",
  null
  
)

export default component.exports